// Formats a date as the local-time "YYYY-MM-DDTHH:mm" value a datetime-local input expects.
// Using toISOString() here would put UTC in the input, which the browser then reads as local time.
export const toLocalDateTimeString = (value: string | Date = new Date()): string => {
  const date = new Date(value)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${year}-${month}-${day}T${hours}:${minutes}`
}
